import {Component, OnInit, ViewEncapsulation, Input} from '@angular/core';
import { DataStorageService } from 'src/app/shared/services/data-storage.service';
import {IntlTellInputService} from '../../shared/services/intl-tell-input.service';

@Component({
    selector: 'intl-tell-input',
    templateUrl: './intl-tell-input.html',
    styleUrls: ['./intl-tell-input.scss'],
    encapsulation: ViewEncapsulation.None
})
export class IntlTellInputComponent implements OnInit {

    public config = {
        initialCountry: 'US',
        autoProcessQueue: false,
        maxFiles: 5,
        addRemoveLinks: true,
        autoReset: null,
        errorReset: null,
        cancelReset: null
    };

    @Input() default_val: string;

    country: String;
    tell: string;
    is_valid: boolean;

    url: string;

    constructor(private dataStorageService: DataStorageService,
                private intlTellInputService: IntlTellInputService
    ) {
        this.country = 'us';
        this.is_valid = false;
    }

    ngOnInit() {

    }

    telInputObject(obj) {
        obj.setCountry('us');
    }

    hasError(e) {
        this.is_valid = !e;
        if (!e) {
            // console.log(e);
            this.intlTellInputService.isTellError.next(e);
        }
    }

    getNumber(e) {
        // console.log(e);
        const tell_raw = e.slice();
        this.tell = e;
        if (this.country === 'us') {
            this.tell = tell_raw.substr(0, 2) + '-' + tell_raw.substr(2, 3) + '-'
                + tell_raw.substr(5, 3) + '-' + tell_raw.substr(8, 4);
        } else if (this.country === 'kr') {
            this.tell = tell_raw.substr(0, 3) + '-' + tell_raw.substr(3, 2) + '-'
                + tell_raw.substr(5, 4) + '-' + tell_raw.substr(9, 4);
        }
        this.intlTellInputService.tellChanged.next(this.tell.slice());
    }

    onCountryChange(e) {
        this.country = e['iso2'];
    }

}
